import { queryOptions } from '@tanstack/react-query'
import { academicTermsApi } from './api'
import { academicTermsKeys } from './keys'

export const academicTermsQueries = {
  getProgramAcademicTerms: (programId: number) => {
    return queryOptions({
      queryKey: academicTermsKeys.programAcademicTerms(programId),
      queryFn: () => {
        return academicTermsApi.getProgramAcademicTerms(programId)
      },
    })
  },

  getGlobalAcademicTerms: () => {
    return queryOptions({
      queryKey: ['global_academic_terms'],
      queryFn: () => {
        return academicTermsApi.getGlobalAcademicTerms()
      },
    })
  },
}
